// extracted by mini-css-extract-plugin
export var banner = "_qt-0";
export var settingRow = "_qt-2";
export var titleIcon = "_qt-1";